import { Controller } from "stimulus";
import { rebind } from "../rebind";
import { railsAjax } from "../../services/rails-ajax";
export default class extends Controller {
  //
  // life cycle
  //
  initialize() {
  }

  //
  // target
  //
  static targets = [
  ]

  //
  // data
  //
  showDetail(e) {
    if (!this.isSp()) {
      return;
    }
    // リンクを無効化する
    e.preventDefault();
    let el = $(e.target);
    let target = el.data('target');
    if (!target) {
      el = $(e.target).closest('li[data-target="calendar--day.data"]');
    }
    const id = el.data('id');
    this.apiShowScheduleDate(id, e, el);
  }
  closeDetail(e) {
    if (!this.isSp()) {
      return;
    }
    $('div[data-target="calendar--day.detail"]').addClass('hidden');
    $('li[data-target="calendar--day.data"]').removeClass('style-active');
  }

  isSp() {
    if (window.innerWidth < 992) {
      return true;
    } else {
      return false;
    }
  }

  //
  // private
  //
  apiShowScheduleDate(id, e, el) {
    railsAjax({
      type: "GET",
      url: `/services/calendar_date/?id=${id}`,
      done: (response) => {
        let $el = $(e.target).closest('div[data-target="calendar--day.weekRoot"]');
        const target = $el.find('div[data-target="calendar--day.detail"]')[0];
        target.innerHTML = response;
        rebind(target);

        // activeにする
        $('div[data-target="calendar--day.detail"]').addClass('hidden');
        $('li[data-target="calendar--day.data"]').removeClass('style-active');
        el.addClass('style-active');
        $(target).removeClass('hidden');
      }
    });
  }
}
